
   

import { useCallback, useContext, useEffect, useState } from 'react'
 

const useDelayShow = (delay: number = 100) => {
  const [show,setShow] = useState(false)
  useEffect(()=> {
    !show && setInterval(()=>setShow(true),delay)
  },[show])
  return show
}

export default useDelayShow